import { render, staticRenderFns } from "./AttachmentsBar.vue?vue&type=template&id=c2ddfcf0&scoped=true&"
import script from "./AttachmentsBar.vue?vue&type=script&lang=js&"
export * from "./AttachmentsBar.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsBar.vue?vue&type=style&index=0&id=c2ddfcf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ddfcf0",
  null
  
)

export default component.exports